import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  ExtendedBox,
  Flex,
  Data,
} from '../../..';

import formatters from '../../../helpers/formatters';

const InvestmentCardActuals = ({
  actualIrr,
  actualHold,
  investmentTypeDisplay,
}) => {
  return (
    <ExtendedBox
      pt={20}
      px={10}
    >
      <Flex
        w={1}
        justify="flex-start"
      >
        <ExtendedBox
          py={10}
          w={1}
        >
          <Data
            type="D6"
            display="block"
            m={0}
          >
            { numeral(actualIrr).format(formatters.PERCENTAGE2) }
          </Data>
          <Data
            pt={5}
            type="D3"
            display="block"
            m={0}
          >
            { investmentTypeDisplay === 'Debt' ? 'Actual Return' : 'Actual IRR' }
          </Data>
        </ExtendedBox>
        <ExtendedBox
          py={10}
          w={1}
        >
          <Data
            type="D6"
            display="block"
            m={0}
          >
            { `${actualHold} MOS` }
          </Data>
          <Data
            pt={5}
            type="D3"
            display="block"
            m={0}
          >
            Actual Hold
          </Data>
        </ExtendedBox>
        <ExtendedBox w={1} />
      </Flex>
    </ExtendedBox>
  );
};

InvestmentCardActuals.propTypes = {
  actualIrr: PropTypes.number,
  actualHold: PropTypes.number,
  investmentTypeDisplay: PropTypes.string,
};

InvestmentCardActuals.defaultProps = {
  actualIrr: 0.999,
  actualHold: '123',
  investmentTypeDisplay: 'Equity',
};

export default InvestmentCardActuals;
